import React from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import styles from "../agent-response.module.scss";

type HrAgentV2HitlAgentProps = {
  parsedContent: any;
};

export default function HrAgentV2HitlAgent({
  parsedContent,
}: HrAgentV2HitlAgentProps): JSX.Element {
  // Following userSlice pattern (lines 535-564, 856-870)
  // parsedContent structure: { answer, question, stepNumber }
  const { answer, question, stepNumber } = parsedContent;

  return (
    <div className={styles.pressReleaseContent}>
      {question && (
        <div style={{ marginBottom: "20px" }}>
          <MarkdownRenderer content={question} />
        </div>
      )}
    </div>
  );
}
